import React from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const ConfirmWarningIcon = ({ size = defaultSize }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 64 64"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect fill="#FFFAEB" height="64" rx="32" width="64" />
    <rect fill="#FEEFC6" height="48" rx="24" width="48" x="8" y="8" />
    <g clipPath="url(#clip0_4718_45131)">
      <rect fill="#DC6803" height="32" rx="16" width="32" x="16" y="16" />
      <circle cx="32" cy="32" fill="white" r="8" />
      <path
        clipRule="evenodd"
        d="M32 18.6667C24.6362 18.6667 18.6666 24.6362 18.6666 32C18.6666 39.3638 24.6362 45.3334 32 45.3334C39.3638 45.3334 45.3333 39.3638 45.3333 32C45.3333 24.6362 39.3638 18.6667 32 18.6667ZM33.3333 26.6667C33.3333 25.9303 32.7363 25.3334 32 25.3334C31.2636 25.3334 30.6666 25.9303 30.6666 26.6667V32.6667C30.6666 33.4031 31.2636 34 32 34C32.7363 34 33.3333 33.4031 33.3333 32.6667V26.6667ZM33.3333 37.2917C33.3333 36.5553 32.7363 35.9584 32 35.9584C31.2636 35.9584 30.6666 36.5553 30.6666 37.2917V37.3334C30.6666 38.0697 31.2636 38.6667 32 38.6667C32.7363 38.6667 33.3333 38.0697 33.3333 37.3334V37.2917Z"
        fill="#DC6803"
        fillRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="clip0_4718_45131">
        <rect fill="white" height="32" rx="16" width="32" x="16" y="16" />
      </clipPath>
    </defs>
  </svg>
);

ConfirmWarningIcon.propTypes = {
  ...sizePropsTypes,
};

export default ConfirmWarningIcon;
